// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x3tNgx_3EAOnVaIfrFSv {
    padding-top: 16px;
    padding-bottom: 16px
}
.gAbfP1JdXDR4r60KPyAV {
    margin-bottom: 14px
}
.PgWimX5nhM0yCZARm5cD {
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem
}
.oAsKToArlyz1T6yWy0Zi {
    margin-top: 1rem;
    display: flex;
    height: 84px;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    --tw-shadow: 0px 0px 40px 0px #0378D117 !important;
    --tw-shadow-colored: 0px 0px 40px 0px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important
}
.zWLewVcQKaP1TIalVFM5 {
    margin-left: 0.75rem;
    border-radius: 9999px;
    background-color: #0082CA1A;
    padding: 0.5rem
}
.U0lkLp728z1zQ5Q75dxc {
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

._Rt7vzNpjbqlYsK6tutv {
    font-family: Noto Sans;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.vOMoNUHkVjsrGW86fcah {
    font-size: 12px;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.p8w45R8ORLnbYdq_krlA {
    cursor: pointer;
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1));
    text-decoration-line: underline
}
.tTHSJjP3gs7W0OTREmmK {
    margin-right: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center
}
.Fumy26O7595f0m0O4D0p {
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1))
}
.ooEUTJTEgUsolF7Kccw2 {
    display: flex;
    align-items: center;
    gap: 0.75rem
}
.ow5cbJ7KpAndHCryrfbm {
    height: 1.25rem;
    width: 1.25rem
}

.MOx8FmVbfRxssL7LebAH {
    margin-top: 1.5rem;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center
}

.t7Qvsww9tGS50jp4pSV3 {
    height: 38px;
    width: 120px;
    --tw-border-opacity: 1;
    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.t7Qvsww9tGS50jp4pSV3:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

.EH2LDQLsoBH7ksFw7CZC {
    margin-top: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notification/Notification.module.css"],"names":[],"mappings":"AACE;IAAA,iBAAgB;IAAhB;AAAgB;AAGhB;IAAA;AAAgB;AAGhB;IAAA,kBAAiC;IAAjC,kBAAiC;IAAjC,4DAAiC;IAAjC;AAAiC;AAGjC;IAAA,gBAA6H;IAA7H,aAA6H;IAA7H,YAA6H;IAA7H,mBAA6H;IAA7H,8BAA6H;IAA7H,kBAA6H;IAA7H,iBAA6H;IAA7H,sBAA6H;IAA7H,4DAA6H;IAA7H,kDAA6H;IAA7H,uEAA6H;IAA7H;AAA6H;AAG7H;IAAA,oBAA8C;IAA9C,qBAA8C;IAA9C,2BAA8C;IAA9C;AAA8C;AAG9C;IAAA,sBAAqE;IAArE,eAAqE;IAArE,gBAAqE;IAArE,oBAAqE;IAArE;AAAqE;;AAIrE;IAAA,sBAAmD;IAAnD,kBAAmD;IAAnD,iBAAmD;IAAnD,gBAAmD;IAAnD,oBAAmD;IAAnD;AAAmD;;AAInD;IAAA,eAAwD;IAAxD,gBAAwD;IAAxD,oBAAwD;IAAxD;AAAwD;;AAIxD;IAAA,eAAsF;IAAtF,sBAAsF;IAAtF,eAAsF;IAAtF,gBAAsF;IAAtF,oBAAsF;IAAtF,iDAAsF;IAAtF;AAAsF;AAGtF;IAAA,qBAA4C;IAA5C,aAA4C;IAA5C,mBAA4C;IAA5C;AAA4C;AAG5C;IAAA,cAAwC;IAAxC,aAAwC;IAAxC,qBAAwC;IAAxC,kBAAwC;IAAxC;AAAwC;AAGxC;IAAA,aAA8B;IAA9B,mBAA8B;IAA9B;AAA8B;AAG9B;IAAA,eAAc;IAAd;AAAc;;AAId;IAAA,kBAAmD;IAAnD,aAAmD;IAAnD,WAAmD;IAAnD,mBAAmD;IAAnD;AAAmD;;AAInD;IAAA,YAAkE;IAAlE,YAAkE;IAAlE,sBAAkE;IAAlE,0DAAkE;IAAlE,kBAAkE;IAAlE,4DAAkE;IAAlE,oBAAkE;IAAlE;AAAkE;;AAIlE;IAAA,iCAAkD;IAAlD,qEAAkD;IAAlD,6BAAkD;IAAlD,uEAAkD;IAAlD,+BAAkD;IAAlD;AAAkD;;AAIlD;IAAA,kBAA6C;IAA7C,aAA6C;IAA7C,mBAA6C;IAA7C;AAA6C","sourcesContent":[".container {\n  @apply py-[16px];\n}\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n.mainContainer {\n  @apply bg-white rounded-[5px] p-6;\n}\n.card {\n  @apply h-[84px] border border-white !shadow-[0px_0px_40px_0px_#0378D117] mt-4 flex items-center rounded-[5px] justify-between;\n}\n.notificationIcon {\n  @apply p-2 rounded-full bg-NotificationBG ml-3;\n}\n.title {\n  @apply font-dashboardMain text-dashboardMain font-inter text-gray-500;\n}\n\n.notificationDescription {\n  @apply font-normal text-xs font-inter text-gray-400;\n}\n\n.timeLable {\n  @apply text-dashboardSub font-dashboardSub text-gray-600;\n}\n\n.applyButton {\n  @apply text-secondary underline text-dashboardMain font-inter font-bold cursor-pointer;\n}\n.rightSideContainer {\n  @apply flex justify-center items-center mr-3;\n}\n.readIcon {\n  @apply w-2 h-2 bg-secondary rounded-full;\n}\n.leftSideContainer {\n  @apply flex items-center gap-3;\n}\n.notificationIconSize {\n  @apply w-5 h-5;\n}\n\n.paginationWrapper {\n  @apply w-full mt-6 flex items-center justify-center;\n}\n\n.clearButton {\n  @apply bg-white text-secondary border-secondary w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.button {\n  @apply flex justify-center items-center mt-10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `x3tNgx_3EAOnVaIfrFSv`,
	"customBreadCrumbs": `gAbfP1JdXDR4r60KPyAV`,
	"mainContainer": `PgWimX5nhM0yCZARm5cD`,
	"card": `oAsKToArlyz1T6yWy0Zi`,
	"notificationIcon": `zWLewVcQKaP1TIalVFM5`,
	"title": `U0lkLp728z1zQ5Q75dxc`,
	"notificationDescription": `_Rt7vzNpjbqlYsK6tutv`,
	"timeLable": `vOMoNUHkVjsrGW86fcah`,
	"applyButton": `p8w45R8ORLnbYdq_krlA`,
	"rightSideContainer": `tTHSJjP3gs7W0OTREmmK`,
	"readIcon": `Fumy26O7595f0m0O4D0p`,
	"leftSideContainer": `ooEUTJTEgUsolF7Kccw2`,
	"notificationIconSize": `ow5cbJ7KpAndHCryrfbm`,
	"paginationWrapper": `MOx8FmVbfRxssL7LebAH`,
	"clearButton": `t7Qvsww9tGS50jp4pSV3`,
	"button": `EH2LDQLsoBH7ksFw7CZC`
};
export default ___CSS_LOADER_EXPORT___;
